import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import { useNavigate } from "react-router-dom";
import { Box, Alert, Button } from "@mui/material";
import { useUser } from '../../context/UserContext';
import { forgotPassword } from '../../api/authService';


const amber = '#B8860A';
const navy = '#1A3A6B';
const pageBg = '#f8f7f2';

const Section = ({ title, children }) => (
  <Box sx={{ border: '1px solid #c8d4de', borderRadius: 1.5, mb: 3, overflow: 'hidden' }}>
    <Box sx={{ bgcolor: '#e4eaf0', borderBottom: '1px solid #c8d4de', px: 3, py: 1.5 }}>
      <span style={{ color: navy, fontWeight: 700, fontSize: '1rem', fontFamily: '"Roboto","Helvetica","Arial",sans-serif' }}>
        {title}
      </span>
    </Box>
    <Box sx={{ p: 3 }}>
      {children}
    </Box>
  </Box>
);

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const {updateUser} = useUser();
  const [userEmail, setUserEmail] = useState("");
  

  const handleChange = (e) => {
    setUserEmail(e.target.value);
    setError(""); // Clear previous error message
    const { name, value } = e.target;
    setEmail(e.target.value);
    updateUser(name, value); // Dynamically update the field
  };
  const handleCancel = () => {
    setUserEmail(""); // Clear the email field
    setError(""); // Clear the error message
    navigate('/');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    //alert("Password reset link has been sent to your email.");

    try {
     
     const { response} = await forgotPassword( email );

      if (response.ok) {
        setSuccess("Email sent successfully!");
        navigate("/ValidateOTP"); // Route to ValidateOTP
      } else {
        const data = await response.json();        
        setError(data.message );
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
    }
  };

  return (
    <Box sx={{ bgcolor: pageBg, minHeight: '100vh', pt: 5, pb: 6, px: { xs: 2, md: 4 }, display: 'flex', justifyContent: 'center' }}>
      <Box sx={{ bgcolor: '#fff', borderRadius: 2, boxShadow: 3, width: '100%', maxWidth: 560, alignSelf: 'flex-start', overflow: 'hidden' }}>

        {/* Page header */}
        <Box sx={{ bgcolor: navy, px: 3, py: 2 }}>
          <span style={{ color: '#fff', fontWeight: 700, fontSize: '1.15rem', fontFamily: 'Georgia, serif', letterSpacing: 0.5 }}>
            Reset Your Password
          </span>
        </Box>

        <Box sx={{ p: { xs: 2, md: 3 } }}>
          <Section title="Forgot Password">
            <p style={{ margin: '0 0 16px', color: '#444', fontSize: '0.95rem', fontFamily: '"Roboto","Helvetica","Arial",sans-serif' }}>
              Enter the email address associated with your account and we'll send you an OTP to reset your password.
            </p>
            <form onSubmit={handleSubmit}>
              <TextField
                type="email"
                required
                fullWidth
                variant="outlined"
                id="email"
                label="Email"
                name="email"
                value={userEmail}
                onChange={handleChange}
              />

              <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
                <Button
                  variant="outlined"
                  onClick={handleCancel}
                  sx={{ flex: 1, borderColor: '#999', color: '#555', fontWeight: 600 }}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  sx={{ flex: 1, bgcolor: amber, color: '#fff', fontWeight: 700, '&:hover': { bgcolor: '#9a6f08' } }}
                >
                  Email Me the OTP
                </Button>
              </Box>

              {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
              {success && <Alert severity="success" sx={{ mt: 2 }}>{success}</Alert>}
            </form>
          </Section>
        </Box>
      </Box>
    </Box>
  );
}
